export default {
    videoNotLoaded: "Video not available in your navigator",
    next: "Next",
    previous: "Previous",
    skipAll: "Skip all",
    finish: "Finish",
    skipTutorial: "Skip tutorial",
    startTutorial: "Start tutorial",
    welcome: {
        title: "Welcome aboard!",
        subtitle:
            "This quick guide  takes just 2 minutes, it will help you get comfortable with the platform in just a few steps.",
        describe: "It’s a virtual world where teams meet, talk, and collaborate naturally",
        describe2: " — just like in real life.",
        describe3: "In this tutorial, you’ll learn how to:",
        bloc1: "Move around",
        bloc2: "Talk with others",
        bloc3: "Discover interactive objects",
    },
    step1: {
        title: "Explore your world",
        use: "Use your",
        arrowkeys: " arrow keys",
        or: "or",
        wasd: "WASD to move your avatar",
        aroundTheMap: "around the map. Try it now!",
        tip: "Tip:",
        describeTip:
            "Hold the Shift key while moving to walk faster — perfect if you’re running late or want to explore more quickly!",
        silentZone: "You’re currently in a Silent Zone — here, no one can hear you.",
    },
    step2: {
        title: "Talk & collaborate",
        describe: "To start a conversation, approach someone ",
        describe2: " — video or audio will launch automatically.",
        describe3: "Click the padlock icon to lock the conversation and make it private.",
        describe4: "Click the “Share Screen” button during a conversation to show your screen",
    },
    step3: {
        title: "Discover & Interact",
        interact: "Interact with objects ",
        likeSign: "like signs, screens, documents and portals",
        sometimes: "— sometimes they light up ",
        closer: "when you get closer.",
        describe3:
            "Gather people in meeting rooms, enhancing spontaneous discussions and teamwork.",
        describe4:
            "Take a break in silent zones, the perfect place to focus and to work without interruptions.",
    },
};
